import React from 'react';
import {Link} from 'react-router-dom';
import AurToast from '../../../common/aur-toast/AurToast';

const Toast: React.FC = () => {
  const toastClick = () => {
    alert('Close');
  };
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Toast</h1>
        <div>Switches toggle the state of a single setting on or off.</div>

        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurToast
            open={true}
            message="Test message"
            severity="success"
            onClose={toastClick}
          />
        </div>
      </div>
    </>
  );
};

export default Toast;
